import { ExpandableSection, Table } from 'AWS-UI-Components-React';

import { summaryDataWithCompositeKeys } from '../utils/transformations';
import {
  extractColumnKey,
  extractColumnKeyPrefix,
  deriveHeadingDisplayKey,
  getForEachCompositeKey,
  getUniqueCompositeKeys,
} from '../utils/composite_keys';
import { formatHeadingDisplay, formatCellDisplay } from '../utils/formatting';

import { TEXT } from '../common/constants';

const COLUMN_CONFIG = Object.freeze({
  cpAccuracy: { heading: 'Total Accuracy' },
  transactionAccuracy: { heading: 'Transactional Accuracy' },
  standardRateAccuracy: { heading: 'Standard Rate Accuracy' },
  predictiveAccuracy: { heading: 'Predictive Accuracy' },
});

const ROW_CONFIG = Object.freeze({
  firstCpAccuracy: { rowLabel: 'First Answer Accuracy' },
  firstCpAvAccuracy: { rowLabel: 'First Answer Accuracy (Abs)' },
  firstCpNvAccuracy: { rowLabel: 'First Answer Accuracy (Net)' },

  lastCpAccuracy: { rowLabel: 'Last Answer Accuracy' },
  lastCpAvAccuracy: { rowLabel: 'Last Answer Accuracy (Abs)' },
  lastCpNvAccuracy: { rowLabel: 'Last Answer Accuracy (Net)' },
});

const ROW_LABEL = 'rowLabel';

/**
 * Component to display the 'Summary Table' on top of the
 * component reports page.
 */
export class ReportSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getReportSummaryData = () => {
    const { responsePayloads, reportData, summaryMapKeys } = this.props;
    const { compositeKeys } = reportData;

    const summaryData = summaryDataWithCompositeKeys(responsePayloads, compositeKeys);

    const reportRows =
      reportData.reportRows && reportData.reportRows.length
        ? Object.keys(ROW_CONFIG)
            .filter((k) => summaryMapKeys.includes(k))
            .map((k) => {
              const config = ROW_CONFIG[k];
              const data = summaryData[k];

              return { [ROW_LABEL]: config.rowLabel, ...data };
            })
        : [];

    const reportKeys = [ROW_LABEL].concat(
      Object.keys(COLUMN_CONFIG)
        .map((k) => {
          return getForEachCompositeKey([k], compositeKeys).flat();
        })
        .flat()
    );

    return { reportRows, reportKeys };
  };

  getColumnDefinitions = (reportSummaryData) => {
    const { reportKeys } = reportSummaryData;
    const uniqueCompositeKeys = getUniqueCompositeKeys(reportKeys);
    const singleDataSet = uniqueCompositeKeys.length === 1;

    let columns = [];

    for (let key of reportKeys) {
      let columnEntry = {};
      columnEntry['id'] = key;
      columnEntry['header'] = () => {
        const columnKey = extractColumnKey(key);
        const columnKeyPrefix = extractColumnKeyPrefix(key, false);
        const headingDisplayKey = singleDataSet ? '' : deriveHeadingDisplayKey(columnKeyPrefix);

        const configuredHeading = COLUMN_CONFIG[columnKey] ? COLUMN_CONFIG[columnKey].heading : '';
        const heading = headingDisplayKey ? `${headingDisplayKey}${configuredHeading}` : configuredHeading;

        return formatHeadingDisplay(heading, 'percent');
      };
      columnEntry['cell'] = (item) => {
        const format = key === ROW_LABEL ? 'string' : 'percent';
        return formatCellDisplay(item[key], format, false);
      };

      columns.push(columnEntry);
    }

    return columns;
  };

  render() {
    const reportSummaryData = this.getReportSummaryData();
    const { reportRows } = reportSummaryData;

    return (
      <div>
        <ExpandableSection header={'Accuracy Summary'} expanded>
          <Table
            className="accuracy-table-container"
            columnDefinitions={this.getColumnDefinitions(reportSummaryData)}
            items={reportRows}
            loadingText={TEXT.LOADING}
            loading={this.props.loading}
            stickyHeader={true}
            wrapLines={false}
            empty={
              <div className="awsui-util-t-c">
                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                  <b>{TEXT.EMPTY}</b>
                </div>
              </div>
            }
          />
        </ExpandableSection>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/report_summary.js